import { SimpleLookup } from "./simple-lookup";

export interface CategorizedLookup extends SimpleLookup {
  CategoryKey: string;
  Value: string;
};
